
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-0780ce10&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Permission.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Permission.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-0780ce10!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Permission.vue"),
  /* scopeId */
  "data-v-0780ce10",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/system/Permission.vue
// module id = 289
// module chunks = 2 3